import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "avatar" }
const _hoisted_2 = ["alt", "src"]

import IconUser from '@/components/icons/User.vue';
import IconUserMobile from '@/components/icons/UserMobile.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserAvatar',
  props: {
    avatarLink: {},
    isMobile: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const Icon = props.isMobile ? IconUserMobile : IconUser;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.avatarLink)
      ? (_openBlock(), _createBlock(_unref(Icon), { key: 0 }))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          alt: _ctx.t('imagesAlt.avatar'),
          src: _ctx.avatarLink
        }, null, 8, _hoisted_2))
  ]))
}
}

})